// extracted by mini-css-extract-plugin
export var container = "_7e-0";
export var error = "_7e-9";
export var label = "_7e-5";
export var light = "_7e-6";
export var md = "_7e-3";
export var sm = "_7e-2";
export var thin = "_7e-8";
export var thinBold = "_7e-7";
export var vertical = "_7e-4";
export var xs = "_7e-1";